<script setup lang="ts">
import { computed } from 'vue';
import { countryFlagEmoji } from '../utils/clickLogUi';

const props = defineProps<{
  code?: string | null;
}>();

const normalized = computed(() => (props.code || '').trim().toUpperCase());
const flag = computed(() => countryFlagEmoji(normalized.value));
const label = computed(() => normalized.value || '—');
</script>

<template>
  <span class="country-cell" :title="label">
    <span v-if="flag" class="country-cell__flag" aria-hidden="true">{{ flag }}</span>
    <span class="country-cell__code mono">{{ label }}</span>
  </span>
</template>

<style scoped>
.country-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.country-cell__flag {
  font-size: 16px;
  line-height: 1;
}

.country-cell__code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.9em;
}
</style>
